import React, { useCallback, useContext } from 'react';
import Global from '../../../../../../store/global-selectors';
import { shallowEqual, useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { EXPORT_PDF } from '../../report-actions/constants';
import ReportFilters from '../../report-filters';
import {
  SHOW_BARCODE_SCAN_ACTION_BY_PROPS,
  SHOULD_SHOW_HOTKEYS_CHECKBOX_PROPS,
} from '../../report-filters/report-paramter-input-properties';
import {
  BARCODE_SCAN_ACTION_TYPE_GENERAL,
  BARCODE_SCAN_ACTION_TYPE_SHIPPING_PRESETS,
  BARCODE_SCAN_ACTION_TYPE_SHIPPING_ORDERS,
  BARCODE_SCAN_ACTION_TYPE_PRINTING_DOCUMENTS,
  BARCODE_SCAN_ACTION_TYPE_NAVIGATION,
} from '../../report-filters/constants';
import { PARAMETER_NAME_SHOW_BARCODE_SCAN_ACTION_BY } from '../../report-filters/report-parameter-names';
import { buildDropdownOptions } from '../../report-filters/filters/dropdown/helpers';
import { ReportsContext } from '../../context';
import { Button } from 'ui-components/components/button';
import { TooltipPosition } from 'ui-components/components/tooltip/tooltip-position';
import shippingOrderBarcodes from './barcode-types/shipping-orders';
import printingDocumentBarcodes from './barcode-types/printing-documents';
import generalBarcodes from './barcode-types/general';
import navigationBarcodes from './barcode-types/navigation';
import { convertPresetToBarcodeProperties } from './preset-to-barcode-conversion-service';
import { useBarcodeScanningFeatureGate } from '../../../../../../feature-gates/use-barcode-scanning-feature-gate';
import messages from './messages';
import style from './style.module.less';

const filtersProps = [SHOW_BARCODE_SCAN_ACTION_BY_PROPS, SHOULD_SHOW_HOTKEYS_CHECKBOX_PROPS];

const scanActionToBarcodeListMap = {
  [BARCODE_SCAN_ACTION_TYPE_GENERAL]: generalBarcodes,
  [BARCODE_SCAN_ACTION_TYPE_SHIPPING_ORDERS]: shippingOrderBarcodes,
  [BARCODE_SCAN_ACTION_TYPE_PRINTING_DOCUMENTS]: printingDocumentBarcodes,
  [BARCODE_SCAN_ACTION_TYPE_NAVIGATION]: navigationBarcodes,
};

const BarcodeScanAction = () => {
  const userPresets = useSelector(Global.selectSellerPresets);
  const intl = useIntl();
  const { handleBarcodeRequest, requestGenerator } = useContext(ReportsContext);
  const updatedFiltersProps = useSelector((state) => buildDropdownOptions({ filtersProps, state }), shallowEqual);

  const request = requestGenerator(EXPORT_PDF);
  const { [PARAMETER_NAME_SHOW_BARCODE_SCAN_ACTION_BY]: barcodeScanActionType } = request;

  const { isFeatureEnabled, disabledMessage } = useBarcodeScanningFeatureGate(); // @design-input-pending

  const runReportOverride = useCallback(() => {
    if (barcodeScanActionType === BARCODE_SCAN_ACTION_TYPE_SHIPPING_PRESETS) {
      const barcodes = convertPresetToBarcodeProperties(userPresets);
      return handleBarcodeRequest({ barcodes });
    }

    const barcodesFromMap = scanActionToBarcodeListMap[barcodeScanActionType];
    const barcodes = barcodesFromMap.map((barcode) => ({
      barcodeContent: barcode.barcodeContent,
      hotkey: barcode.hotkey.toString(),
      name: intl.formatMessage(barcode.intlFormattedName),
    }));

    handleBarcodeRequest({ barcodes });
  }, [barcodeScanActionType, handleBarcodeRequest, intl, userPresets]);

  return (
    <>
      <ReportFilters filtersProps={updatedFiltersProps} />
      <div className={style['hotkey-action-buttons']}>
        <Button
          disabled={!isFeatureEnabled}
          disabledTooltipMessage={<FormattedMessage {...disabledMessage} />}
          disabledTooltipMessagePosition={TooltipPosition.Bottom}
          onClick={() => runReportOverride(EXPORT_PDF)}
          theme='primary'
        >
          <FormattedMessage {...messages.exportDirectlyToPdf} />
        </Button>
      </div>
    </>
  );
};

export default BarcodeScanAction;
